import { render, staticRenderFns } from "./BaseModalNew.vue?vue&type=template&id=acb4e1ba&scoped=true"
import script from "./BaseModalNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModalNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseModalNew.vue?vue&type=style&index=0&id=acb4e1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb4e1ba",
  null
  
)

export default component.exports